<template>
  <div v-if="!isViewMode && !data || data">
    <prozess-search-dropdown
      v-model="data"
      :placeholder="$t(label)"
      :loading="loading"
      :can-handle-new-item="false"
      :options="items"
      :error="error"
      :hint="hint"
      :icon="icon"
      :disabled="disabled"
      @search="handleSearch"
      @clear="handleClear"
      @blur="handleBlur"
    />
  </div>
</template>

<script>
import metaStatusService from '@/services/metastatus'

export default {
  name: 'CustomEntitySearch',
  props: {
    originalEntityKey: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    value: {
      default: null,
      type: [String, Number, Object],
    },
    isMainEntity: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: null,
    },
    error: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    uuidKey: {
      type: String,
      default: null,
    },
    isViewMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: this.value,
      items: [],
      loading: false,
    }
  },
  watch: {
    data() {
      this.$emit('input', this.uuidKey, this.data)
    },
    value(data) {
      this.data = data
    },
  },

  methods: {
    handleClear() {
      this.items = []
      this.$emit('input', null)
    },
    handleBlur() {
      this.items = []
    },
    handleSearch(search) {
      search = search.trim()
      if (search === '' || search.length < 3) return
      this.loading = true

      metaStatusService.autocomplete('category', 'company_contact', search.trim())
        .then(res => {
          this.items = res.data.map(item => ({
            label: item.categoryName || '',
            categoryId: item.categoryId,
          }))
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
